/** Invoice filter states  **/
export const FILTER_STATES = [
  '',
  'monthly',
  'individual',
  'partly',
  'deposit',
  'cancellation',
];

const InvoicesFilterFormatter = (e, filters) => {
  const { id, checked } = e.currentTarget;
  let updateFilters = [...filters];
  const filterId = parseInt(id);
  const filterIndex = filters.findIndex((filter) => filter.id === filterId);
  if (filterIndex === 0) {
    updateFilters = filters.map((filter) => ({ ...filter, value: checked }));
  } else {
    updateFilters[filterIndex].value = checked;
    const dd = updateFilters.filter((item, ind) => ind !== 0 && ind !== 7);
    const allTrue = dd.every((filter) => filter.value);
    updateFilters[0].value = allTrue;
  }
  return updateFilters;
};

/** Helper for Appointments List query
 * formats filters, search into query
 * @param {array} filters filter options array
 * **/
const InvoicesQueryFormatter = (filters) => {
  let query = ``;
  if (filters[0].value) {
    return query;
  }
  filters.forEach((filter, index) => {
    if (index < 7 && filter.value) {
      query = query.concat(`&filterType[]=${ FILTER_STATES[index] }`);
    }
  });
  return query;
};

export {
  InvoicesFilterFormatter,
  InvoicesQueryFormatter
};
